<template>
    <Modal @closeModal="closeModal">
      <template #header>
        <div class="px10 cursor-pointer d-flex justify-between items-center">
          <span class="inline-block">{{ title }} </span>
          <i class="fas fa-times" @click="closeModal"></i>
        </div>
      </template>
  
      <template #body>
        <span v-if="message" class="block" v-html="message"></span>
        <div class="d-flex items-center mt10">
          <button @click="handleAction" class="btn btn-xs btn-green d-flex items-center text-xs max-content-width">
            <span>{{$t('mediaClipper.clippingMetadata.confirm_action')}}</span>
          </button>
          <button @click="closeModal" class="ml10 btn btn-xs btn-carma d-flex items-center text-xs max-content-width">
            <span>{{$t('mediaClipper.clippingMetadata.cancel')}}</span>
          </button>
        </div>
      </template>
    </Modal>
  </template>
  
  <script>
  import Modal from '../modal.vue';
  
  export default {
    components: {
      Modal
    },
    methods: {
      handleAction: function() {
        if (this.actionType) {
            this.$emit('action', this.actionType, this.assetData)
        }
      }
    },
    props: {
      closeModal: Function,
      assetData: Object,
      title: String,
      actionType: String,
      message: String,
    }
  }
  </script>

  <style scoped lang="scss">
    .btn-green{
      background:  #0c8300;
    }
  </style>

  